<template>
  <div
    class="fixed inset-0 z-50 overflow-auto flex items-center justify-center p-2 | modal-mask"
    @click="clickHandler"
  >
    <div
      class="relative px-6 pt-2 pb-4 w-full m-auto flex-col flex bg-grey-1 border border-grey-3 rounded shadow-lg"
      :class="'max-w-' + size"
      @click.stop
    >
      <div class="modal-header">
        <slot name="header">
          <div class="flex justify-end">
            <a class="text-lg cursor-pointer text-grey-7 hover:text-blue-7" @click="$emit('close')">
              <x-square-icon class="m-2"></x-square-icon>
            </a>
          </div>
        </slot>
      </div>

      <div class="mt-2 mb-6">
        <slot>default body</slot>
      </div>

      <div class="modal-footer">
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { XSquareIcon } from "vue-feather-icons"

export default {
  name: "Modal",
  components: {
    XSquareIcon
  },
  props: {
    size: {
      default: "md"
    },
    closeOnClick: {
      default: true
    }
  },
  methods: {
    clickHandler() {
      if (!this.closeOnClick) return
      this.$emit("close")
    }
  }
}
</script>

<style scoped lang="scss">
</style>
